import request from '@/utils/request'
// 查询安全库存类别定义头列表
export function listSopClassifyDefinitionHeadList (query) {
    return request({
      url: '/scp/sopClassifyDefinitionHead/list',
      method: 'get',
      params: query
    })
  }
   // 新增安全库存类别定义头
  export function apiNewlistSopClassifyDefinitionHead (data) {
    return request({
      url: '/scp/sopClassifyDefinitionHead',
      method: 'post',
      data: data
    })
  }
   // 查询安全库存成品物料列表
   export function apiItemProductAttributeList (data) {
    return request({
      url: '/mdm/itemProductAttribute/list',
      method: 'get',
      params: data
    })
  }
     // 新增安全库存类别定义头
     export function apiDellistSopClassifyDefinitionHead (data) {
      return request({
        url: '/scp/sopClassifyDefinitionHead',
        method: 'delete',
        params: data
      })
    }
